export const PNG = 'image/png';
export const JPG = 'image/jpeg';
export const JPEG = 'image/jpeg';
export const XLSX =
  'application/' + 'vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const XLS = 'application/' + 'vnd.ms-excel';
export const DOC = 'application/' + 'msword';
export const DOCX =
  'application/' +
  'vnd.openxmlformats-officedocument.wordprocessingml.document';
export const PDF = 'application/' + 'pdf';
export const TXT = 'text/' + 'plain';
